import React from 'react';
import { useEffect, useState, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';

import { Typography, Button, Box, TextField, Select, OutlinedInput, Chip, MenuItem } from '@mui/material';
import { supabase } from '../../../api';
import { PROFILE_TABLE } from '../../../constants/supabase_constants';

const StepFourLinkedinSkills = (props) => {
  const [loading, setLoading] = useState(true);
  const [firstName, setFirstName] = useState(null);
  const [linkedin, setLinkedin] = useState(null);
  const [skills, setSkills] = useState(null);

  const skillsList = [
    'Bootstrapping',
    'Building a team',
    'Content marketing',
    'Conversion rate optimization',
    'Copywriting',
    'Customer success',
    'Data science',
    'Design / UX',
    'Email marketing',
    'Facebook ads',
    'Go to market strategy',
    'Google ads',
    'Growth marketing',
    'Idea validation',
    'Link building',
    'Operations',
    'Marketing automation',
    'No-code',
    'Performance marketing',
    'PPC strategies',
    'Pricing strategy',
    'Product analytics',
    'Product management',
    'Product market fit',
    'Public relations',
    'Raising funding',
    'Sales',
    'SEO',
    'Social media',
    'User research',
    'Web Development',
  ];

  const handleSkillsChange = (event) => {
    const {
      target: { value },
    } = event;
    setSkills(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  let { id } = useParams();

  useEffect(() => {
    getProfile();
    // eslint-disable-next-line
  }, []);

  const getProfile = async () => {
    try {
      setLoading(true);
      let { data, error, status } = await supabase
        .from(PROFILE_TABLE)
        .select(`firstName, linkedin, skills`)
        .eq('id', id)
        .single();

      if (data) {
        setFirstName(data.firstName);
        setLinkedin(data.linkedin);
        setSkills(data.skills);
      }

      if (error && status !== 406) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async () => {
    try {
      setLoading(true);
      // const user = supabase.auth.user();

      const updates = {
        id: id,
        linkedin: formik.values.linkedin,
        skills,
        updated_at: new Date(),
      };

      console.log(updates);

      let { error } = await supabase.from(PROFILE_TABLE).upsert(updates, {
        returning: 'minimal', // Don't return the value after inserting
      });

      if (error) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const validationSchema = yup.object({
    linkedin: yup.string('Enter your LinkedIn').required('LinkedIn is required'),
  });

  const formik = useFormik({
    initialValues: {
      linkedin: linkedin,
      //   skills: skills,
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log('Are you triggering');
      updateProfile();
      props.handleNext();
    },
  });

  return (
    <Fragment>
      {loading ? (
        'Loading ...'
      ) : (
        <Fragment>
          <Typography variant='h4' sx={{ mt: '3rem', mb: '2rem', fontWeight: 'bold' }}>
            You’re doing great, {firstName}! We’re almost done with getting to know you.
          </Typography>

          <form onSubmit={formik.handleSubmit}>
            <TextField
              fullWidth
              id='linkedin'
              name='linkedin'
              label='Drop your personal LinkedIn link here'
              sx={{
                mb: '1rem',
              }}
              value={formik.values.linkedin}
              onChange={formik.handleChange}
              error={formik.touched.linkedin && Boolean(formik.errors.linkedin)}
              helperText={formik.touched.linkedin && formik.errors.linkedin}
            />

            <Typography variant='body1' sx={{ my: '1rem', fontWeight: 'bold' }}>
              What are your top skills that people can find you for? (5 Max)
            </Typography>
            <Select
              fullWidth
              id='skills'
              name='skills'
              label='Select 2 skills'
              multiple
              value={skills || ''}
              onChange={handleSkillsChange}
              sx={{ mb: '1.5rem' }}
              input={<OutlinedInput id='select-multiple-chip' label='Chip' />}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}>
              {skillsList.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>

            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Button color='inherit' disabled={props.activeStep === 0} onClick={props.handleBack} sx={{ mr: 1 }}>
                Back
              </Button>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button type='submit'>Next</Button>
            </Box>
          </form>
        </Fragment>
      )}
    </Fragment>
  );
};

export default StepFourLinkedinSkills;
